/**
 * @generated SignedSource<<a4a3b0019ec06dd9f425d4c339abe9e4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TeamCard$data = {
  readonly description: string | null;
  readonly displayName: string | null;
  readonly id: string | null;
  readonly members: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly aaid: string | null;
        readonly pii: {
          readonly name: string | null;
          readonly picture: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "TeamCard";
};
export type TeamCard$key = {
  readonly " $data"?: TeamCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "TeamCard",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "concreteType": "TeamMemberConnection",
      "kind": "LinkedField",
      "name": "members",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "concreteType": "TeamMemberEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "TeamMember",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "aaid"
                },
                {
                  "concreteType": "UserPII",
                  "kind": "LinkedField",
                  "name": "pii",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "name"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "picture"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "TeamSearchResponse"
};

(node as any).hash = "20f60f2eee887f44c86bf9a087dabf0d";

export default node;
